import * as React from "react";
const SvgFiRrGuide = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-guide_svg__a)">
      <path
        fill="#062147"
        d="M7 12c3.309 0 6-2.691 6-6h1a1 1 0 1 0 0-2h-1.35C11.824 1.673 9.607 0 7 0 3.691 0 1 2.691 1 6s2.691 6 6 6m0-2c-2.206 0-4-1.794-4-4h8c0 2.206-1.794 4-4 4m0-8c1.474 0 2.75.81 3.444 2H3.556C4.25 2.81 5.526 2 7 2m6.601 16.666A7 7 0 0 1 14 21v2a1 1 0 1 1-2 0v-2a5 5 0 0 0-.284-1.666.999.999 0 1 1 1.885-.668m9.964-15.302L20 5.249v3.814c0 .893-.394 1.733-1.08 2.305l-4.723 3.937a3 3 0 0 1-1.921.695H7c-2.757 0-5 2.243-5 5v2a1 1 0 1 1-2 0v-2c0-3.859 3.141-7 7-7h5.276c.233 0 .461-.082.64-.231l4.724-3.938c.229-.19.36-.47.36-.768V1a1 1 0 0 1 1-1c.6 0 1.195.128 1.751.377l2.813 1.259c.581.399.581 1.329 0 1.729z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-guide_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGuide;
